"use client";

import * as React from "react";
import { Route as ReactRoute, RouteProps, useLocation } from "react-router-dom";

import { removeLocaleFromUrl } from "./util";

export const Route = <T extends RouteProps>(props: T) => {
  const currentLocation = useLocation();
  const { location: overriddenLocation } = props;

  const augmentedLocation = React.useMemo(() => {
    const newLocation = {
      ...currentLocation,
      ...overriddenLocation,
    };
    newLocation.pathname = removeLocaleFromUrl(newLocation.pathname);
    return newLocation;
  }, [currentLocation, overriddenLocation]);

  const augmentedPath = React.useMemo(
    () => (props.path ? removeLocaleFromUrl(`${props.path}`) : ""),
    [props.path]
  );

  if (!augmentedPath) {
    return <ReactRoute {...props} location={augmentedLocation} />;
  }

  return (
    <ReactRoute {...props} path={augmentedPath} location={augmentedLocation} />
  );
};
